import Navbar from "src/components/Landing/Navbar";
import { useEffect, useState } from "react";
import courses from "../data/courses.json";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { IBlog, Video } from "src/types";
import APIService from "src/services/Api";
import process from "process";
import { AiOutlineLike } from "react-icons/ai";
import { ImSpinner9 } from "react-icons/im";
import { classNames, getSlug, getSubString } from "src/helpers/mixins";
import CardWall from "src/components/Dashboard/CardWall";
import { useAppStateContext } from "src/auth/AppStateContext";
import { getImageCourse } from "src/components/Academy/AcademyList";

const NewsHomePage = () => {
  const { id } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState<boolean>(false);
  const [videos, setVideos] = useState<Video[]>([]);

  /* const { t } = useTranslation(); */

  const { blogs, fetchBlogs } = useAppStateContext();
 
  const fetchVideos = async () => {
    setLoading(true);

    await APIService.getToken();
    const res = await APIService.videoList({type:'normal',status:'active'});
    let videos = res?.data?.data?.videos as Video[];
      fetchBlogs();

    setVideos(videos);
    setLoading(false);
  };

  /*   const handleVisit = (id: string) => {
    navigate(`/videos/${id}`);
  }; */

  useEffect(() => {
    fetchVideos();
  }, []);

  
 
 

  return (
    <div className="bg-[#f5f5f5]">
      <Navbar />
      <section
        className={classNames(
          location.pathname === "/videos" ? "mt-20" : "",
          "w-5/6 mx-auto"
        )}
      >
        <div className="font-semibold text-xl pt-6 mb-2">
          Bienvenido a Intercambios sin fronteras{" "}
        </div>
        <div className="text-bold mb-2 font-semibold">
          Inicia sesión para más.
        </div>
        {loading && (
          <div className="flex items-center justify-center mt-10">
            <ImSpinner9 size={33} className="animate-spin" />
          </div>
        )}
        <div className="grid grid-cols-6 items-center gap-2">
          {courses?.map((course, index) => (
            <div className="col-span-2 md:col-span-1 mx-auto rounded overflow-hidden">
              <Link to={`/academia/detalle/${index}`}>
                <img
                  className="w-full cursor-pointer"
                  src={getImageCourse(course.position)}
                  alt="Imagen curso academia"
                />
              </Link>
            </div>
          ))}
        </div>
        {/*  {id && (
          <div className="grid grid-cols-6 gap-6">
            <div className="col-span-6 lg:col-span-4">
              {videos.some((v) => v.id === id) && (
                <ReactPlayer
                  url={`${process.env.REACT_APP_VIDEO}${
                    videos.find((v) => v.id === id)?.videoUrl
                  }`}
                  width="100%"
                  controls
                  onPlay={() => dispatchCounters("play", videos.find((v) => v.id === id)?.id || '')}
                  onEnded={() => dispatchCounters('ended', videos.find((v) => v.id === id)?.id || '')}
                />
              )}
              <div className="text-2xl font-bold mt-2">
                {videos.find((v) => v.id === id)?.name}
              </div>
              <div className="font-semibold">
              {videos.find((v) => v.id === id)?.views} Vistas.
              </div>
              <div className="flex items-center gap-2 mb-2">
                <img
                  src={LogoComment}
                  alt="logoISF"
                  className="w-8 rounded-full"
                />
                <div className="flex items-center justify-between w-full">
                  <span className="font-semibold">ISF OFICIAL</span>
                  <div
                    onClick={() => (!loadingLike ? handleLike(id) : null)}
                    className="flex text-xl  font-bold items-center gap-1 cursor-pointer"
                    title="Presiona para dar Like"
                  >
                    <>
                      {!loadingLike ? (
                        <>
                          <AiOutlineLike size={28} />
                          {videos.find((v) => v.id === id)?.likes}
                        </>
                      ) : (
                        <ImSpinner9 className="animate-spin" size={22} />
                      )}
                    </>
                  </div>
                </div>
              </div>
              <div
                onClick={() => setViewMore(!viewMore)}
                className="bg-stone-200 px-2 py-2 rounded-md mb-2 lg:mb-40 font-normal"
              >
                El contenido de este video es propiedad intelectual de
                www.ISFCambios.com y está protegido por leyes de derechos de
                autor.
                {viewMore && 
                  <>
                    <div>
                      <div>Uso permitido</div>
                      <ul>
                        <li>Visualización personal</li>
                        <li>Compartir en redes sociales (con atribución)</li>
                      </ul>
                      <div>Uso prohibido</div>
                      <ul>
                        <li>Modificar o editar el contenido</li>
                        <li>
                          Utilizar para fines comerciales sin permiso Derechos de
                          autor
                        </li>
                        <li>
                          www.ISFCambios.com es titular de los derechos de autor del
                          contenido
                        </li>
                      </ul>
                    </div>
                    www.ISFCambios.com se reserva el derecho de tomar medidas
                    legales contra cualquier infracción de derechos de autor
                    Información adicional <br /> Para obtener permiso para utilizar
                    el contenido, contacta con servicio al cliente <br />
                    Para obtener más información sobre nuestros términos y
                    condiciones, visita terminos-y-condiciones.
                    <ul>
                      <li>
                        El contenido de este video no es una recomendación de
                        inversión
                      </li>
                      <li>
                        El trading conlleva riesgos y no es adecuado para todos los
                        inversores
                      </li>
                      <li>
                        Consulta con un asesor financiero antes de tomar decisiones
                        de inversión.
                      </li>
                      <li>
                        Recuerda adaptar el contenido a tus necesidades específicas
                        y asegurarte de cumplir con las regulaciones y leyes
                        aplicables en tu país.
                      </li>
                    </ul>
                  </>
                }
                {!viewMore ?
                  <span className="font-bold text-base px-2 cursor-pointer" onClick={() => setViewMore(true)}>Ver más...</span>
                :
                <span className="font-bold text-base px-2 cursor-pointer" onClick={() => setViewMore(false)}>Ver menos...</span>
                }
              </div>
            </div>

            <div className="col-span-6 lg:col-span-2 relative">
              <div className="flex flex-col gap-4">

                
                {videos?.map((v, key) => (
                  <div
                    onClick={() => handleVisit(v.id)}
                    key={key.toString()}
                    className="flex flex-col gap-2 relative cursor-pointer"
                  >
                    <div className="father-prevideo cursor-pointer">
                      <img
                        src={`${process.env.REACT_APP_VIDEO}${v.photoUrl}`}
                        alt={v.name}
                        className="image-prevideo w-full cursor-pointer"
                      />
                      <div className="middle-video flex items-center justify-center">
                        <FaCirclePlay size={72} className="mx-auto" />
                      </div>
                    </div>

                    <div className="flex flex-col gap-2">
                      <div className="flex gap-3 items-start">
                        <div className="flex items-center gap-2 mb-2">
                          <img
                            src={LogoComment}
                            alt="logoISF"
                            className="w-14 rounded-full relative top-1"
                          />
                        </div>
                        <div>
                          <div className="font-semibold text-base">
                            {v.name}
                          </div>

                          <div>
                            <div className="flex justify-between items-center gap-2">
                              <div className="text-xs text-gray-500">
                                ISF OFICIAL
                              </div>
                              <div className="flex items-center gap-1">
                                <AiOutlineLike size={18} />
                                {v.likes}
                              </div>
                            </div>

                            <div className="text-xs text-gray-500">
                              {v.views} visitas
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )} */}
        {!id && (
          <>
            <div className="px-2 py-2 rounded-sm grid grid-cols-3 lg:grid-cols-4 mt-10">
              <div className="col-span-3  xl:pl-6 lg:pr-10 xl:pr-16">
                {videos.length > 0 && location.pathname.includes("/videos") && (
                  <PrintVideos videoList={videos} />
                )}

                {blogs.length > 0 && location.pathname.includes("/blog") && (
                  <PrintBlog blogList={blogs} />
                )}
              </div>

              <div className=" col-span-3 lg:col-span-1 grid md:grid-cols-1 gap-4">
                {blogs.length > 0 && location.pathname.includes("/videos") && (
                  <PrintBlog blogList={blogs} />
                )}

                {videos.length > 0 && location.pathname.includes("/blog") && (
                  <PrintVideos videoList={videos} />
                )}
              </div>
            </div>
          </>
        )}
      </section>
    </div>
  );
};

type paramPrintVideos = {
  videoList: Video[];
};
type paramPrintBlog = {
  blogList: IBlog[];
};
const PrintVideos = ({ videoList }: paramPrintVideos) => {
  const [loadingLike, setLoadingLike] = useState<boolean>(false);
  /* const [viewMore, setViewMore] = useState<boolean>(false); */
  const [videos, setVideos] = useState<Video[]>(videoList);
  const [watched, setWatched] = useState<boolean>(false);
  const { id } = useParams();

  useEffect(() => {
    /* setViewMore(false); */
    setWatched(false);
  }, [id]);

  const handleLike = async (id: any) => {
    setLoadingLike(true);
    await APIService.videoLike({ videoId: id });
    videos?.map((v) => {
      if (v.id === id) {
        v.likes = Number(v.likes) + 1;
      }
      return v;
    });
    setLoadingLike(false);
  };

  const savePlayed = async (type: string, id:string) => {
    await APIService.videoUpdateViews({ type, videoId: id });
  };

  const dispatchCounters = (action: string, id: string) => {

      if (action === "play") {
        savePlayed("view",id);
      } else if (action === "ended") {
        savePlayed("completed",id);
      }
      setVideos(
        videos?.map((v) => {
          if (v.id === id) {
            v.views = Number(v.views) + 1;
          }
          return v;
        })
      );
  };

  return (
    <>
      {videos
      ?.sort((a:any,b:any) => Date.parse(b.createdAt) - Date.parse(a.createdAt))
      ?.map((v, key) => (
        <>
          <CardWall
            title={v.name}
            key={key.toString()}
            autor={"ISF Cambios"}
            description={v?.description}
          >
            <div>
              <video
                className="w-full bg-[#000] h-80"
                controls
                poster={`${process.env.REACT_APP_VIDEO}${v?.photoUrl}`}
                onPlay={() => dispatchCounters("play", v.id)}
              >
                <source
                  src={`${process.env.REACT_APP_VIDEO}${v.videoUrl}`}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
              <div className="flex items-center justify-between px-4 mt-2">
                <div>{v.views} vistas</div>
                <div
                  onClick={() => (!loadingLike ? handleLike(v.id) : null)}
                  className="flex cursor-pointer items-center gap-2 font-bold "
                >
                  <>
                    {!loadingLike ? (
                      <>
                        <AiOutlineLike size={28} />
                        {v.likes}
                      </>
                    ) : (
                      <ImSpinner9 className="animate-spin" size={22} />
                    )}
                  </>
                </div>
              </div>
            </div>
          </CardWall>
        </>
      ))}
    </>
  );
};

const PrintBlog = ({ blogList }: paramPrintBlog) => {
  const [blogs] = useState(blogList);
  const navigate = useNavigate();
  return (
    <div>
      {blogs
        ?.filter((_, i) => i < 3)
        ?.map((b, k) => (
          <>
            <CardWall
              title={b.title}
              key={k.toString()}
              autor={"ISF Cambios"}
              description={
                <div className="text-sm">
                  {getSubString(b.content.substring(0, 200))}
                  <div
                    className="cursor-pointer mt-2 font-semibold"
                    onClick={() => navigate("/blog/" + getSlug(b.title))}
                  >
                    Ver más...
                  </div>
                </div>
              }
            >
                <img
                  alt="blog"
                  onClick={() => navigate("/blog/" + getSlug(b.title))}
                  className="w-full cursor-pointer bg-black h-auto "
                  src={`${process.env.REACT_APP_BLOG_IMAGE}${b.photo}`}
                />
             
            </CardWall>
          </>
        ))}
    </div>
  );
};

export default NewsHomePage;
